import { Seo } from '@frontend/shared/web';
import { NavLink } from 'react-router-dom';

export const NotFoundRoute = () => (
  <main className="min-h-viewport flex flex-col items-center justify-center bg-extranet-bg px-4">
    <Seo title="404 — Portail extranet" />

    <div className="flex flex-col items-center gap-4 text-center">
      <p className="font-mono text-sm text-extranet-text-tertiary">404</p>
      <h1 className="text-2xl font-semibold tracking-tight text-extranet-text-primary">
        Cette page n&apos;existe pas.
      </h1>
      <p className="text-extranet-text-secondary max-w-md">
        Le lien que vous avez suivi est peut-être obsolète ou vous n&apos;avez pas les droits pour y accéder.
      </p>
      <NavLink
        to="/login"
        className="mt-2 inline-flex items-center justify-center rounded-md bg-extranet-accent px-4 py-2 text-sm font-medium text-extranet-accent-foreground hover:bg-extranet-accent-hover transition"
      >
        Retour à la connexion
      </NavLink>
    </div>
  </main>
);
